/*
  This file manages dealer state for the dealer photography app.
  It is backed by sessionStorage rather than module variables so the
  dealer's identity survives a page refresh or PWA relaunch - the photos
  already persist in IndexedDB, and losing one but not the other left
  users stuck mid-flow.
*/
export function setGlobalDealerName(dealerName) {
  sessionStorage.setItem('dealer_name', dealerName);
}

export function getGlobalDealerName() {
  return sessionStorage.getItem('dealer_name');
}

export function setGlobalDealerID(dealerID) {
  sessionStorage.setItem('dealer_id', dealerID);
}

export function getGlobalDealerID() {
  return sessionStorage.getItem('dealer_id');
}

/*
  Frame style chosen on the FrameSelection screen ('Chrome', 'Black',
  'Custom'); rides along with the plate submission so the art team knows
  which frame to pair with the plate.
*/
export function setFrameChoice(choice) {
  sessionStorage.setItem('frame_choice', choice);
}

export function getFrameChoice() {
  return sessionStorage.getItem('frame_choice');
}

/*
  Wipe dealer identity at the end of a flow so the next user (or the same
  user starting a fresh job) begins with a clean slate instead of relying
  on tab-close to clear sessionStorage.
*/
export function clearGlobalState() {
  sessionStorage.removeItem('dealer_name');
  sessionStorage.removeItem('dealer_id');
  sessionStorage.removeItem('frame_choice');
}
